import React, {Component} from 'react';
import {connect}          from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form';
import validate           from '../../service/validate_login';
import {authentic,recuperarSenha}        from '../../actions/authenticActions'
import {jwtToken}         from '../../actions/configActions';
import renderField             from '../../container/renderField';
import '../../css/aluno/bootstrap-grid.css';
import '../../css/aluno/core.css';
import '../../css/aluno/hud.css';
import '../../css/aluno/action.css';
import "../../css/aluno/colors.css";
import '../../css/aluno/login.css';
import Logo from '../../img/logo.svg'
import SvgEsquerdo from './svgEsquerdo';
import SvgDireito from './svgDireito';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
                    login      : "",
                    senha      : "",
                    load       : true,
                    textButton : 'Entrar',
                    textButtonEmail : 'Enviar',
                    acesso     : false,
                    statusForm: false
                  }
  }

  componentWillMount() {

    if(this.props.isAuthenticated){
       this.setState({acesso:true})
    }
  }

  handleSubmit(e) {


    if (e.use_email){
   
       this.setState({textButtonEmail: 'Enviando...',load:false})
      this.props.recuperarSenha(e.use_email).then((response) => {
    
  
        })
        // .catch((error)=>{
        //   this.setState({textButton: 'Entrar',load:true})
        //   alert('O seu login ou senha está incorreta.');
        // });

      
    } else {


    this.setState({textButton: 'Carregando...',load:false})
    this.props.authentic(e).then((response) => {
     
        const token        = response.payload.data.token;
        const session      = response.payload.data.session[0];
        const pontuacao    = (response.payload.data.session[0].pontuacao     ? response.payload.data.session[0].pontuacao : null);

        (response.payload.data.session[0].novo_talento  ? localStorage.setItem('novo_talento', JSON.stringify(true)) : null);
        (response.payload.data.session[0].acesso_diario ? localStorage.setItem('acesso_diario', JSON.stringify(true)) : null);
       
        localStorage.setItem('jwtToken', token);
        localStorage.setItem('session', JSON.stringify(session));
        localStorage.setItem('pontuacao', JSON.stringify(pontuacao));
      
        jwtToken(token);
        window.location.assign(`${this.props.config.raiz}/home`);

      }).catch((error)=>{
        this.setState({textButton: 'Entrar',load:true})
        alert('O seu login ou senha está incorreta.');
      });
      
    }
  }


  forms(acao){
    this.setState({statusForm:acao})
  }

  render() {
    
      const {handleSubmit} = this.props;

      return ( 
              <div className="login">
          <div className="login-ceil">
            <div className="login-ceil-center">
              <div className="logo">
                <img src={Logo} alt="" />
              </div>
            </div>
          </div>
          <div className="login-middle">
              <SvgEsquerdo />
            <div className="login-middle-portal">
              <div className="login-middle-portal-door">
                <a href="javascript:Login.Enable()" className="login-middle-portal-door-opener">
                  <span className="decoration">&lsaquo;</span>
                  <span className="decoration decoration-60">&lsaquo;</span>
                  <span className="decoration decoration-30">&lsaquo;</span>
                  <span className="text">Login</span>
                  <span className="decoration">&rsaquo;</span>
                  <span className="decoration decoration-60">&rsaquo;</span>
                  <span className="decoration decoration-30">&rsaquo;</span>
                </a>
                {!this.state.statusForm?
                <form className="login-middle-portal-door-form" onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                  <div className="inputs">
                    <div className="input input-with-decoration">
                        <Field name="login" component="input" component={renderField} type="text" placeholder="Usuário"/>
                      {/* <div className="marker">&rsaquo;</div> */}
                    </div>
                    <div className="input input-with-decoration">
                       <Field name="senha" component={renderField} type="password" placeholder="Senha"/>
                      {/* <div className="marker">&rsaquo;</div> */}
                    </div>
                   
                  </div>
                  <div className="input">
                  <button type="submit" className="action" disabled={!this.state.load}>{this.state.textButton}</button>
                  </div>

                   <br/>
                    <div className="esqueci_senha">
                    <a href={void(0)} onClick={this.forms.bind(this,true)} className="">Esqueci Senha</a>
                    </div>
                </form>:
                
                <form className="login-middle-portal-door-form" onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                  <div className="inputs">
                    <div className="input input-with-decoration">
                        <Field name="acao" component={renderField} type="hidden" valueForm="1"/>
                        <Field name="use_email" component={renderField} type="text" placeholder="Email"/>
                      {/* <div className="marker">&rsaquo;</div> */}
                    </div>
                   
                    <br/>
                    <div className="esqueci_senha">
                    <a href={void(0)} onClick={this.forms.bind(this,false)} className="">Voltar</a>
                    </div>
                  </div>
                  <div className="input">
                  <button type="submit" className="action" disabled={!this.state.load}>{this.state.textButtonEmail}</button>
                  </div>
                </form>
                }
              </div>
            </div>
              <SvgDireito />
          </div>
          <div className="login-floor">
            <div className="login-floor-center">

            </div>
          </div>
              </div>          
             )
  }
}
const afterSubmit = (result, dispatch) => dispatch(reset('missoes_form'));

function mapStateToProps(state){
    return {
             isAuthenticated : state.auth.isAuthenticated,
             config          : state.configReducer.menu
           };
}

export default reduxForm({
  form                     : 'login', 
  destroyOnUnmount         : true,
  forceUnregisterOnUnmount : true, 
  onSubmitSuccess          : afterSubmit,
  validate
})(connect(mapStateToProps, {authentic,recuperarSenha})(Login));




// WEBPACK FOOTER //
// ./src/components/login/login.js